import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert, Row } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
const GrandfatherNotice = () => {
  return (
    <Alert
      message={
        <FormattedMessage defaultMessage="This feature is not available on your subscription plan" />
      }
      type="warning"
      className="alert-with-description"
      icon={<InfoCircleOutlined />}
      showIcon
      description={
        <>
          <FormattedMessage defaultMessage="Any settings already made for this feature will remain but cannot be changed, only disabled. If you disable the feature, you must upgrade your plan to reactivate it." />
          <Row className="gutter-top-m" />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://learn.acast.com/en/articles/9823206-acast-s-free-starter-plan"
          >
            <FormattedMessage defaultMessage="Learn more" />
          </a>
        </>
      }
    />
  );
};

export default GrandfatherNotice;
